const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true,
    width: 200
  },
  {
    prop: 'timezone',
    label: 'TimeZone',
    sortable: true,
    width: 200
  },
  {
    prop: 'createdOn',
    label: 'Created on',
    sortable: true,
    width: 150
  },
  {
    prop: 'status',
    label: 'Status',
    sortable: true
  },
  {
    prop: 'surveillance',
    label: 'Biosecurity',
    sortable: true
  }
];

const sensorTableColumns = [
  {
    prop: 'name',
    label: 'Orchard',
    sortable: false,
    width: 250
  },
  {
    prop: 'sensorName',
    label: 'Trap name',
    sortable: false,
    width: 300
  },
  {
    prop: 'dateDeployed',
    label: 'Deployed on',
    sortable: false,
    width: 200
  }
];

const userTableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true,
    width: 300
  },
  {
    prop: 'username',
    label: 'Username',
    sortable: false,
    width: 300
  },
  {
    prop: 'roles',
    label: 'Role(s)',
    sortable: false,
    width: 300
  }
];

const tableFilters = [
  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Email',
        value: 'email'
      },
      {
        label: 'Produce',
        value: 'produce'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions, sensorTableColumns, userTableColumns };
